__turbopack_context__.v({
  "fileDropImage": "kNP5CG_fileDropImage",
  "icon": "kNP5CG_icon",
  "lightbulb": "kNP5CG_lightbulb",
  "photos": "kNP5CG_photos",
  "skip": "kNP5CG_skip",
});
